import { supabase } from './supabaseClient';

// ==================== PURCHASE ORDERS ====================

export const fetchPurchaseOrders = async (userId) => {
  const { data, error } = await supabase
    .from('purchase_orders')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching POs:', error);
    return [];
  }
  return data;
};

export const savePurchaseOrder = async (userId, po) => {
  const { data, error } = await supabase
    .from('purchase_orders')
    .upsert({
      id: po.id,
      user_id: userId,
      po_number: po.poNumber,
      date: po.date,
      vendor: po.vendor,
      project: po.project,
      delivery_date: po.deliveryDate || null, // Convert empty string to null
      delivery_address: po.deliveryAddress || null,
      terms: po.terms,
      items: po.items,
      notes: po.notes || null,
      prepared_by: po.preparedBy || null,
      approved_by: po.approvedBy || null,
      subtotal: po.subtotal,
      total_gst: po.totalGST,
      grand_total: po.grandTotal,
    })
    .select()
    .single();

  if (error) {
    console.error('Error saving PO:', error);
    throw error;
  }
  return data;
};

export const deletePurchaseOrder = async (poId) => {
  const { error } = await supabase
    .from('purchase_orders')
    .delete()
    .eq('id', poId);

  if (error) {
    console.error('Error deleting PO:', error);
    throw error;
  }
};

// ==================== VENDORS ====================

export const fetchVendors = async (userId) => {
  const { data, error } = await supabase
    .from('vendors')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching vendors:', error);
    return [];
  }
  return data;
};

export const saveVendor = async (userId, vendor) => {
  const { data, error } = await supabase
    .from('vendors')
    .upsert({
      id: vendor.id,
      user_id: userId,
      name: vendor.name,
      contact: vendor.contact,
      phone: vendor.phone,
      email: vendor.email,
      gst: vendor.gst,
      address: vendor.address,
    })
    .select()
    .single();

  if (error) {
    console.error('Error saving vendor:', error);
    throw error;
  }
  return data;
};

export const deleteVendor = async (vendorId) => {
  const { error } = await supabase
    .from('vendors')
    .delete()
    .eq('id', vendorId);

  if (error) {
    console.error('Error deleting vendor:', error);
    throw error;
  }
};

// ==================== PROJECTS ====================

export const fetchProjects = async (userId) => {
  const { data, error } = await supabase
    .from('projects')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching projects:', error);
    return [];
  }
  return data;
};

export const saveProject = async (userId, project) => {
  const { data, error } = await supabase
    .from('projects')
    .upsert({
      id: project.id,
      user_id: userId,
      name: project.name,
      code: project.code,
      budget: project.budget,
      spent: project.spent,
    })
    .select()
    .single();

  if (error) {
    console.error('Error saving project:', error);
    throw error;
  }
  return data;
};

export const deleteProject = async (projectId) => {
  const { error } = await supabase
    .from('projects')
    .delete()
    .eq('id', projectId);

  if (error) {
    console.error('Error deleting project:', error);
    throw error;
  }
};

// ==================== COMPANY PROFILE ====================

export const fetchCompanyProfile = async (userId) => {
  const { data, error } = await supabase
    .from('company_profile')
    .select('*')
    .eq('user_id', userId)
    .single();

  if (error && error.code !== 'PGRST116') {
    // PGRST116 = no rows returned (acceptable for first time)
    console.error('Error fetching company profile:', error);
  }
  return data;
};

export const saveCompanyProfile = async (userId, profile) => {
  const { data, error } = await supabase
    .from('company_profile')
    .upsert({
      user_id: userId,
      name: profile.name,
      address: profile.address,
      phone: profile.phone,
      email: profile.email,
      gst: profile.gst,
      pan: profile.pan,
    })
    .select()
    .single();

  if (error) {
    console.error('Error saving company profile:', error);
    throw error;
  }
  return data;
};